import {PageViewportLayout} from "../../components/template";
import {FlexBox} from "@brg/ui";
import {FC, ReactNode} from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import { LayoutConst } from "core";
import { ProjectEditPageGridRow } from "../projectEdit/styles";

export const MainHeader = styled.h1`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;
    white-space: nowrap;
    color: #151514;
    margin: 0;
    letter-spacing: -0.86px;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 34px;
        line-height: 41px;
        margin: 0 10px;
    }
    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 30px;
        line-height: 34px;
    }
`;

interface examPageEditProps {
    juriesInput: ReactNode
    competitionStatusInput: ReactNode
    startDateInput: ReactNode
    endDateInput: ReactNode
    competitionExamNameInput: ReactNode
    saveButton: ReactNode
    longReadBlock: ReactNode
    paidApplicationInput: ReactNode
    isModer?: boolean
}

export const ExamPageEdit: FC<examPageEditProps> = (props) => {

    const {
        juriesInput,
        competitionStatusInput,
        startDateInput,
        endDateInput,
        competitionExamNameInput,
        saveButton,
        longReadBlock,
        paidApplicationInput,
        isModer
    } = props

    const { t } = useTranslation()
    
    return <PageViewportLayout offsetTop={0}>
        <ProjectEditPageGridRow offsetTop={16} offsetBottom={32} offsetBottomMobile={24}>
            <MainHeader>{t('teams.adminPage.exam_header')}</MainHeader>
        </ProjectEditPageGridRow>
        <FlexBox directionMobile="column" direction="column" offsetRightMobile={10} offsetLeftMobile={10}>
            {competitionExamNameInput}
            {startDateInput}
            {endDateInput}
            {competitionStatusInput}
            {juriesInput}
            {isModer && paidApplicationInput}
            {longReadBlock}
            <FlexBox offsetTop={24} justify="flex-end">
                {saveButton}
            </FlexBox>
        </FlexBox>
    </PageViewportLayout>
}import {PageViewportLayout} from "../../components/template";
import {FlexBox} from "@brg/ui";
import {FC, ReactNode} from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import { LayoutConst } from "core";
import { ProjectEditPageGridRow } from "../projectEdit/styles";

export const MainHeader = styled.h1`
    font-family: 'Inter';
    font-weight: 600;
    font-size: 43px;
    line-height: 51px;
    white-space: nowrap;
    color: #151514;
    margin: 0;
    letter-spacing: -0.86px;

    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 34px;
        line-height: 41px;
        margin: 0 10px;
    }
    @media(max-width: ${LayoutConst.screen.s -1}px) {
        font-size: 30px;
        line-height: 34px;
    }
`;

interface examPageEditProps {
    juriesInput: ReactNode
    competitionStatusInput: ReactNode
    startDateInput: ReactNode
    endDateInput: ReactNode
    competitionExamNameInput: ReactNode
    saveButton: ReactNode
    longReadBlock: ReactNode
    paidApplicationInput: ReactNode
    isModer?: boolean
}

export const ExamPageEdit: FC<examPageEditProps> = (props) => {

    const {
        juriesInput,
        competitionStatusInput,
        startDateInput,
        endDateInput,
        competitionExamNameInput,
        saveButton,
        longReadBlock,
        paidApplicationInput,
        isModer
    } = props

    const { t } = useTranslation()
    
    return <PageViewportLayout offsetTop={0}>
        <ProjectEditPageGridRow offsetTop={16} offsetBottom={32} offsetBottomMobile={24}>
            <MainHeader>{t('teams.adminPage.exam_header')}</MainHeader>
        </ProjectEditPageGridRow>
        <FlexBox directionMobile="column" direction="column" offsetRightMobile={10} offsetLeftMobile={10}>
            {competitionExamNameInput}
            {startDateInput}
            {endDateInput}
            {competitionStatusInput}
            {juriesInput}
            {isModer && paidApplicationInput}
            {longReadBlock}
            <FlexBox offsetTop={24} justify="flex-end">
                {saveButton}
            </FlexBox>
        </FlexBox>
    </PageViewportLayout>
}